import React, { useEffect, useState } from "react"
import { Flex } from "@rebass/grid/emotion"
import Image from "../image"
import "../modal/modal.css"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { Filterbar } from "@nutrafol/nutrafol-ui-kit/dist/Filterbar"
import Select from "react-select"
import styled from "@emotion/styled"
import { css } from "@emotion/react"

export const ModalBoxCSS = css`
  justify-content: center;
  align-items: baseline;
  padding: 20px 12px 0 12px;
  .FilterBar {
    section {
      margin: 0 auto 16px;
      border-bottom: none;
      ul {
        margin: 0 auto;
        padding: 0;
      }
      li {
        border-bottom: solid 0.2px #e7ebf0;
        padding: 0 15px 15px;
        margin: 0;
        width: auto;
        /* width: 33%; */
        &.currentCSS {
          border-bottom: solid 2px rgb(34, 32, 47);
        }
      }

      button {
        padding: 0;
        margin: 0;
        font-size: 16px;
        font-weight: 300;
        font-family: ${theme.wild.font.dinamo.regular};
        text-align: center;
        letter-spacing: 0;
        line-height: 24px;
        &.current {
          font-weight: 500;
          font-family: ${theme.wild.font.dinamo.bold};
        }
      }
    }
  }
`

const SupplementModalWrap = styled.div``

const ImagesWrap = styled(Flex)`
  .c-label {
    width: 100%;
    max-width: 400px;
    margin: 20px auto;
  }
  .gatsby-image-wrapper {
    max-width: 440px !important;
    margin: auto;
  }
  .c-img {
    width: 55%;
    margin: 0 0 0 0;
    transform: translate(60px, 10px);
  }
`

const ImagesWrapMobile = styled.div`
  .c-visible {
    margin: 36px auto 42px;
    * {
      object-fit: contain !important;
    }
    &.c-visible-1 {
      transform: translateX(12%);
    }
  }
  .c-label {
    margin: 0 0 0 0;
  }
  .c-img {
    width: 55%;
  }

  section {
    align-items: center;
    display: flex;
    width: 114px;
    margin: 0 auto;
    > div {
      width: 48px;
      height: 48px;
    }

    .active {
      border: 1px solid rgb(227, 227, 227);
    }
    .item1 {
      border: 1px solid #fff;
    }
    .item2 {
      border: 1px solid #fff;
    }
    .gatsby-image-wrapper {
      transform: translate(2px, 2px);
      padding: 0px;
      width: 42px;
      height: 42px;
    }
  }
`

const SupplementModal = (props) => {
  const products = props.products
  const activeProduct = props.activeProduct
  const labels = Object.keys(products) || []
  const options = labels.map((item) => {
    return {
      label: item,
      value: item,
    }
  })
  const [filter, changeFilter] = useState(activeProduct)
  const [preview] = useState(0)
  const handleChange = (e) => {
    changeFilter(e.value)
  }

  useEffect(() => {
    changeFilter(activeProduct)
  }, [activeProduct])

  return (
    <SupplementModalWrap className={`SupplementModal`}>
      <Flex className="column" css={ModalBoxCSS}>
        <div className={`SelectBar hide-md-up`}>
          <Select
            className={`react-select react-select-has-vegan`}
            isSearchable={false}
            defaultValue={options[0]}
            value={{ label: filter, value: filter }}
            options={options}
            onChange={handleChange}
          />
          <ImagesWrapMobile>
            <Image
              filename={
                [products[filter].label, products[filter].imgv2][preview]
              }
              classes={`c-visible c-visible-${preview}`}
            />
          </ImagesWrapMobile>
        </div>
        <div className={`FilterBar show-md-up`}>
          <Filterbar
            currentlySelected={filter}
            handleFilterClick={changeFilter}
            labels={labels}
          />
          <ImagesWrap>
            <Image
              filename={products[filter].label}
              classes={`c-label ${filter}`}
            />
          </ImagesWrap>
        </div>
      </Flex>
    </SupplementModalWrap>
  )
}

export default SupplementModal
